module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Form not found","description":"The form you are trying to access no longer exists or has a configuration error.","developed":"Developed by"},"pt-BR":{"title":"Formulário não encontrado","description":"O formulário que está tentando acessar não existe mais ou está com erro de configuração.","developed":"Desenvolvido por"}}')
  delete Component.options._Ctor
}
